// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Education_buttonsContainer__2gbYj","buttonsDescription":"Education_buttonsDescription__1WKdx","button":"Education_button__3gJNG"};